import React from "react";

function ComedyFeature() {
  return (
    <div>
      <section className="comedy-feature">
        <div className="container-fluid p-0">
          <div className="row g-0">
            <div className="col-12 col-lg-6">
              <div className="comedy-feature-image">
                <img
                  src="/s3/comedy-feature.jpg"
                  alt="Comedian performing with a microphone"
                />
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <div className="comedy-feature-content">
                <h2 className="comedy-feature-title futuraPTBold">
                  Laugh Out Loud. Make It a
                  Night to Remember.
                </h2>

                <p className="comedy-feature-text">
                  Get ready for an evening of nonstop laughter featuring talented
                  comedians, unforgettable performances, and an atmosphere built
                  for fun. Whether you’re planning a date night, celebrating with
                  friends, or simply looking for a great time, our comedy shows
                  deliver big laughs, great food, and entertainment that keeps you
                  coming back for more.
                </p>

                <a href="/#upcoming-events" className="btn comedy-feature-button">
                  View Upcoming Comedy Events
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ComedyFeature;
